export const fieldNameWatchType = 'watchType';
export const fieldNameSelectedCompanies = 'selectedCompanies';
